import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, FormGroup, Button } from "react-bootstrap";
import MediaQuery from "react-responsive";
import moment from "moment";
import { CartItemPreview } from "../CartItemPreview";
import Wrapper from "../../wrapper/Wrapper";
import { TravelOptions, TravelButton, RetailShippingOptions } from "../Travel";
import { SectionBanner } from "../CheckoutHelpers";
import { handleModNames } from "../../../util";
import { TimingOptions } from "./index";
import { ShippingSelect } from "./ShippingSelect";
import { FaShippingFast } from 'react-icons/fa';
import leadtimeVectorImg from "../../../images/leadtime-vector.png";
import { AuthenticationState } from 'react-aad-msal';
import CartItem from './CartItem';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';
export var itemHandler = function itemHandler(amt) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "item";
  return amt > 1 ? "".concat(text, "s") : "".concat(text);
};
export var TotalHeading = function TotalHeading(props) {
  return /*#__PURE__*/React.createElement(LocationInfo, props);
};
export var LocationInfo = function LocationInfo(_ref) {
  var alternate_name = _ref.alternate_name,
      alternateName = _ref.alternateName,
      _ref$storeaddress = _ref.storeaddress;
  _ref$storeaddress = _ref$storeaddress === void 0 ? {} : _ref$storeaddress;
  var value = _ref$storeaddress.value,
      address1 = _ref.address1,
      phone = _ref.phone,
      state = _ref.state,
      zip = _ref.zip,
      city = _ref.city;
  return Boolean(alternate_name || alternateName) && /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__location"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-cart__order-from-header"
  }, "Ordering from: ", alternate_name || alternateName), Boolean(value || address1) && /*#__PURE__*/React.createElement("div", null, value || address1), Boolean(city) && /*#__PURE__*/React.createElement("div", null, city, ", ", state, ", ", zip), Boolean(phone) && /*#__PURE__*/React.createElement("a", {
    href: "tel:" + phone
  }, phone));
};
export var MobileTotal = function MobileTotal(_ref2) {
  var _ref2$total = _ref2.total,
      total = _ref2$total === void 0 ? 0 : _ref2$total,
      destructuredCart = _ref2.destructuredCart,
      layout = _ref2.layout,
      _ref2$subTotalCost = _ref2.subTotalCost,
      subTotalCost = _ref2$subTotalCost === void 0 ? 0 : _ref2$subTotalCost,
      _ref2$location = _ref2.location,
      location = _ref2$location === void 0 ? {} : _ref2$location,
      isFood = _ref2.isFood,
      isCatering = _ref2.isCatering,
      isRetail = _ref2.isRetail;

  var childLayout = _objectSpread(_objectSpread({}, layout), {}, {
    topPadding: layout.padding,
    padding: undefined
  });

  var _destructuredCart$foo = destructuredCart.foodItems,
      foodItems = _destructuredCart$foo === void 0 ? [] : _destructuredCart$foo,
      _destructuredCart$cat = destructuredCart.caterItems,
      caterItems = _destructuredCart$cat === void 0 ? [] : _destructuredCart$cat,
      _destructuredCart$ret = destructuredCart.retailItems,
      retailItems = _destructuredCart$ret === void 0 ? [] : _destructuredCart$ret;
  var foodLength = foodItems.length;
  var caterLength = caterItems.length;
  var retailLength = retailItems.length;
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: childLayout
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-cart__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__total-header--wrapper"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-cart__total-header"
  }, total, " ", itemHandler(total), " in cart: $", subTotalCost.toFixed(2)), Boolean(foodLength) && /*#__PURE__*/React.createElement("div", null, "Food - ", foodLength, " ", itemHandler(foodLength)), Boolean(caterLength) && /*#__PURE__*/React.createElement("div", null, "Cater - ", caterLength, " ", itemHandler(caterLength)), Boolean(retailLength) && /*#__PURE__*/React.createElement("div", null, "Retail - ", retailLength, " ", itemHandler(retailLength)), Boolean(isFood || isCatering) && /*#__PURE__*/React.createElement(LocationInfo, location), window.location.href.toLowerCase().indexOf("cart") !== -1 ? null : /*#__PURE__*/React.createElement("a", {
    href: "/cart"
  }, "Back to cart"))))));
};
export var OrderHeader = function OrderHeader(_ref3) {
  var title = _ref3.title,
      amt = _ref3.amt,
      _ref3$location = _ref3.location,
      location = _ref3$location === void 0 ? {} : _ref3$location;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__order-header ".concat(Boolean((location === null || location === void 0 ? void 0 : location.alternate_name) || (location === null || location === void 0 ? void 0 : location.alternateName)) && "d-block")
  }, /*#__PURE__*/React.createElement("h3", null, title));
};
export var Cost = function Cost(props) {
  var _props$Subtotal = props.Subtotal,
      Subtotal = _props$Subtotal === void 0 ? 0 : _props$Subtotal,
      _props$TaxTotal = props.TaxTotal,
      TaxTotal = _props$TaxTotal === void 0 ? 0 : _props$TaxTotal,
      _props$ShippingTotal = props.ShippingTotal,
      ShippingTotal = _props$ShippingTotal === void 0 ? 0 : _props$ShippingTotal,
      _props$HandlingTotal = props.HandlingTotal,
      HandlingTotal = _props$HandlingTotal === void 0 ? 0 : _props$HandlingTotal,
      _props$DeliveryCharge = props.DeliveryCharge,
      DeliveryCharge = _props$DeliveryCharge === void 0 ? 0 : _props$DeliveryCharge,
      _props$OloTip = props.OloTip,
      OloTip = _props$OloTip === void 0 ? 0 : _props$OloTip,
      _props$TotalSavings = props.TotalSavings,
      TotalSavings = _props$TotalSavings === void 0 ? 0 : _props$TotalSavings,
      _props$GiftCardTotal = props.GiftCardTotal,
      GiftCardTotal = _props$GiftCardTotal === void 0 ? 0 : _props$GiftCardTotal,
      _props$Total = props.Total,
      Total = _props$Total === void 0 ? 0 : _props$Total,
      _props$CateringDiscou = props.CateringDiscount,
      CateringDiscount = _props$CateringDiscou === void 0 ? 0 : _props$CateringDiscou,
      children = props.children,
      _props$showSummary = props.showSummary,
      showSummary = _props$showSummary === void 0 ? true : _props$showSummary,
      _props$OloCateringTip = props.OloCateringTip,
      OloCateringTip = _props$OloCateringTip === void 0 ? 0 : _props$OloCateringTip,
      _props$Remaining = props.Remaining,
      Remaining = _props$Remaining === void 0 ? 0 : _props$Remaining,
      _props$Used = props.Used,
      Used = _props$Used === void 0 ? 0 : _props$Used,
      isFinal = props.isFinal,
      isRetail = props.isRetail,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      paymentMethod = props.paymentMethod,
      values = props.values,
      _props$giftCardInfo = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo === void 0 ? {
    num: 0
  } : _props$giftCardInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__cost"
  }, showSummary && /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 990
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__summary-header"
  }, "Summary")), /*#__PURE__*/React.createElement("ul", {
    className: "cb-cart__cost-list"
  }, /*#__PURE__*/React.createElement(CostLine, {
    cost: Subtotal,
    title: "Subtotal"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: DeliveryCharge,
    title: "Delivery"
  }), isRetail && /*#__PURE__*/React.createElement(CostLine, {
    cost: isFinal ? ShippingTotal || "FREE" : ShippingTotal,
    title: "Shipping"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: HandlingTotal,
    title: "Handling"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: TotalSavings,
    isNegative: true,
    isBold: true,
    title: "Redeemed Rewards"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: CateringDiscount,
    isNegative: true,
    title: "Catering Discount"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: TaxTotal,
    title: isFinal ? "Final Tax" : "Estimated tax"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: OloTip,
    title: "Tip"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: OloCateringTip,
    title: "Catering Tip"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: GiftCardTotal,
    isNegative: true,
    title: "Gift Card"
  }), /*#__PURE__*/React.createElement("li", {
    className: "cb-cart__cost-list-item cb-cart__cost-list-item--total"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, "$", Total.toFixed(2))), // Boolean(Array.isArray(giftCardInfo) ? giftCardInfo.length : giftCardInfo.num) && giftCardInfo.map((el, i) => {
  Boolean(Array.isArray(giftCardInfo)) && typeof Remaining !== "undefined" && Remaining > 0 &&
  /*#__PURE__*/
  // console.log('Card: ', el)
  // return (
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CostLine, {
    cost: Used,
    isNegative: true,
    title: "Gift Card"
  }), /*#__PURE__*/React.createElement("li", {
    className: "cb-cart__cost-list-item cb-cart__cost-list-item--total"
  }, /*#__PURE__*/React.createElement("span", null, "Remaining"), /*#__PURE__*/React.createElement("span", null, "$", Remaining.toFixed(2)))) //   )
  // })
  , Boolean(giftCardInfo.balance && Used) && typeof Remaining !== "undefined" && Remaining > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CostLine, {
    cost: Used,
    isNegative: true,
    title: "Gift Card"
  }), /*#__PURE__*/React.createElement("li", {
    className: "cb-cart__cost-list-item cb-cart__cost-list-item--total"
  }, /*#__PURE__*/React.createElement("span", null, "Remaining"), /*#__PURE__*/React.createElement("span", null, "$", Remaining.toFixed(2))))), children);
};

var CostLine = function CostLine(_ref4) {
  var _ref4$cost = _ref4.cost,
      cost = _ref4$cost === void 0 ? 0 : _ref4$cost,
      title = _ref4.title,
      isNegative = _ref4.isNegative,
      _ref4$isBold = _ref4.isBold,
      isBold = _ref4$isBold === void 0 ? false : _ref4$isBold;
  return Boolean(cost) && /*#__PURE__*/React.createElement("li", {
    className: "cb-cart__cost-list-item ".concat(isBold ? 'cb-cart__cost-list-item--bold' : '')
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", null, typeof cost === "number" ? "".concat(isNegative ? "-$" : "$").concat(cost.toFixed(2)) : cost));
};

moment.fn.roundNext15Min = function () {
  var intervals = Math.floor(this.minutes() / 15);
  if (this.minutes() % 15 != 0) intervals++;

  if (intervals == 4) {
    this.add('hours', 1);
    intervals = 0;
  }

  this.minutes(intervals * 15);
  this.seconds(0);
  return this;
};

export var CartOptionSelect = function CartOptionSelect(props) {
  var _props$fullCart, _props$values, _props$fullCart2, _props$fullCart2$food;

  var title = props.title,
      _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      values = props.values,
      _props$leadtimeErr = props.leadtimeErr,
      leadtimeErr = _props$leadtimeErr === void 0 ? "" : _props$leadtimeErr;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLeadtimeErr = _useState2[0],
      setLeadTimeErr = _useState2[1];

  useEffect(function () {
    if (leadtimeErr != "") {
      setLeadTimeErr(true);
    } else {
      setLeadTimeErr(false);
    }
  }, [leadtimeErr]);

  var deleteField = function deleteField(name) {
    // console.log('DELETING PROP ',name,values)
    delete values[name]; // console.log('NEW OBJ',values)
  };

  var isAsapFood = (props === null || props === void 0 ? void 0 : (_props$fullCart = props.fullCart) === null || _props$fullCart === void 0 ? void 0 : _props$fullCart.isFood) && (props === null || props === void 0 ? void 0 : (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.foodTime) == "asap";
  var minutes = props === null || props === void 0 ? void 0 : (_props$fullCart2 = props.fullCart) === null || _props$fullCart2 === void 0 ? void 0 : (_props$fullCart2$food = _props$fullCart2.food) === null || _props$fullCart2$food === void 0 ? void 0 : _props$fullCart2$food.LeadTimeEstimateMinutes;
  var estimateTimeReadyVerbiage = 'Estimated ready time: ';

  if (Number.isInteger(minutes)) {
    estimateTimeReadyVerbiage += Number(minutes) - 0 + '-' + (Number(minutes) + 5) + ' mins';
  } else {
    estimateTimeReadyVerbiage += '15-20 mins';
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__order-details-sections-inner"
  }, /*#__PURE__*/React.createElement(SectionBanner, {
    value: "".concat(title, " Delivery Options"),
    index: index,
    activeCategoryIndex: index
  }), /*#__PURE__*/React.createElement(TravelOptions, _extends({}, props, {
    deleteField: deleteField
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__order-details-sections-inner"
  }, /*#__PURE__*/React.createElement(TimingOptions, _extends({
    deleteField: deleteField,
    index: index
  }, props))), isAsapFood && title == "Food" && /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__order-details-sections-inner"
  }, !showLeadtimeErr && /*#__PURE__*/React.createElement("p", {
    className: "cb-color-brown-500 mb-3"
  }, estimateTimeReadyVerbiage), showLeadtimeErr && leadtimeErr !== "" && /*#__PURE__*/React.createElement(Row, {
    className: "leadtime-error-container"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "leadtime-error-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: leadtimeVectorImg,
    alt: "error-leadtime"
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: "10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leadtime-text-container"
  }, leadtimeErr === null || leadtimeErr === void 0 ? void 0 : leadtimeErr.map(function (leadtimeErrTxt) {
    return /*#__PURE__*/React.createElement("p", {
      className: "leadtime-error"
    }, leadtimeErrTxt);
  }))))));
};
export var CartRetailSelect = function CartRetailSelect(props) {
  var title = props.title,
      _props$index2 = props.index,
      index = _props$index2 === void 0 ? 0 : _props$index2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionBanner, {
    value: "".concat(title, " Shipping Options"),
    index: index,
    activeCategoryIndex: index
  }), /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(ShippingSelect, props), /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, "Shipping fees will be added once details are filled out on the next page")));
};
export var CartLineGroup = function CartLineGroup(_ref5) {
  var _ref5$items = _ref5.items,
      items = _ref5$items === void 0 ? [] : _ref5$items,
      isCheckout = _ref5.isCheckout,
      title = _ref5.title,
      _ref5$stashEdit = _ref5.stashEdit,
      _stashEdit = _ref5$stashEdit === void 0 ? function () {
    return "";
  } : _ref5$stashEdit,
      _ref5$patchItem = _ref5.patchItem,
      patchItem = _ref5$patchItem === void 0 ? function () {
    return "";
  } : _ref5$patchItem,
      _ref5$deleteItem = _ref5.deleteItem,
      deleteItem = _ref5$deleteItem === void 0 ? function () {
    return "";
  } : _ref5$deleteItem,
      _ref5$offlineCart = _ref5.offlineCart,
      offlineCart = _ref5$offlineCart === void 0 ? false : _ref5$offlineCart,
      rewardsState = _ref5.rewardsState,
      authenticationState = _ref5.authenticationState,
      removeItemRewardsConfirmationFields = _ref5.removeItemRewardsConfirmationFields;

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      badges = _useState4[0],
      setBadges = _useState4[1];

  var isFirstRender = useRef(true);
  var flags = useFlags();
  var ldClient = useLDClient();
  var releaseRedemptionEngineV2 = flags['releaseRedemptionEngineV2PromosDstr6078'] ? flags['releaseRedemptionEngineV2PromosDstr6078'] : false;

  var getBadges = function getBadges(redeemedCartItems) {
    var releaseRedemptionEngineV2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var badgesAux = [];

    if (redeemedCartItems.length) {
      items.forEach(function (item, index) {
        if (releaseRedemptionEngineV2) {
          var redeemedItem = redeemedCartItems.find(function (redeemedItem) {
            return redeemedItem.oloItemId === item.Product.ProductChainId && parseInt(redeemedItem.lineId) === index + 1;
          });

          if (redeemedItem) {
            var _redeemedItem$rewardI;

            if ((_redeemedItem$rewardI = redeemedItem.rewardItemsApplied) === null || _redeemedItem$rewardI === void 0 ? void 0 : _redeemedItem$rewardI.length) {
              var bonusReward = false,
                  pegs = false;
              redeemedItem.rewardItemsApplied.forEach(function (reward) {
                if (reward.couponCode) {
                  bonusReward = true;
                } else {
                  pegs = (redeemedItem.pegValue || 0) * (reward.iterationsApplied || 1);
                }
              });

              if (bonusReward) {
                badgesAux["".concat(item.Product.ProductChainId, "-").concat(index + 1)] = 'Bonus Reward';
              } else if (pegs) {
                badgesAux["".concat(item.Product.ProductChainId, "-").concat(index + 1)] = "".concat(pegs, " pegs");
              }
            }
          }
        } else {
          var _redeemedItem = redeemedCartItems.find(function (redeemedItem) {
            return redeemedItem.productChainId === item.Product.ProductChainId && parseInt(redeemedItem.cartLineItem) === index + 1;
          });

          if (_redeemedItem) {
            badgesAux["".concat(item.Product.ProductChainId, "-").concat(index + 1)] = _redeemedItem.redemptionType === 'points' ? "".concat(_redeemedItem.pointsRedeemed, " pegs") : 'Bonus Reward';
          }
        }
      });
    }

    setBadges(badgesAux);
  };

  useEffect(function () {
    var asyncUseEffect = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _rewardsState$rewards, _rewardsState$rewards2, _rewardsState$rewards3, _rewardsState$customR, _rewardsState$customR2, _rewardsState$customR3;

        var type;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isFirstRender.current) {
                  _context.next = 3;
                  break;
                }

                isFirstRender.current = false;
                return _context.abrupt("return");

              case 3:
                if (!ldClient) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return ldClient.waitForInitialization();

              case 6:
                _context.next = 9;
                break;

              case 8:
                return _context.abrupt("return");

              case 9:
                if (!(authenticationState === AuthenticationState.Authenticated)) {
                  _context.next = 26;
                  break;
                }

                if (!(rewardsState && rewardsState.redeemedRewards && items.length)) {
                  _context.next = 23;
                  break;
                }

                type = rewardsState.redeemedRewards.type;
                _context.t0 = type;
                _context.next = _context.t0 === 'recommended' ? 15 : _context.t0 === 'custom' ? 17 : 19;
                break;

              case 15:
                getBadges(((_rewardsState$rewards = rewardsState.rewardsRedemptionResponse) === null || _rewardsState$rewards === void 0 ? void 0 : (_rewardsState$rewards2 = _rewardsState$rewards.redeemOptions) === null || _rewardsState$rewards2 === void 0 ? void 0 : (_rewardsState$rewards3 = _rewardsState$rewards2[0]) === null || _rewardsState$rewards3 === void 0 ? void 0 : _rewardsState$rewards3.cart) || [], releaseRedemptionEngineV2);
                return _context.abrupt("break", 21);

              case 17:
                getBadges(((_rewardsState$customR = rewardsState.customRewardsRedemptionResponse) === null || _rewardsState$customR === void 0 ? void 0 : (_rewardsState$customR2 = _rewardsState$customR.redeemOptions) === null || _rewardsState$customR2 === void 0 ? void 0 : (_rewardsState$customR3 = _rewardsState$customR2[0]) === null || _rewardsState$customR3 === void 0 ? void 0 : _rewardsState$customR3.cart) || [], releaseRedemptionEngineV2);
                return _context.abrupt("break", 21);

              case 19:
                setBadges([], releaseRedemptionEngineV2);
                return _context.abrupt("break", 21);

              case 21:
                _context.next = 24;
                break;

              case 23:
                setBadges([], releaseRedemptionEngineV2);

              case 24:
                _context.next = 27;
                break;

              case 26:
                setBadges([], releaseRedemptionEngineV2);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function asyncUseEffect() {
        return _ref6.apply(this, arguments);
      };
    }();

    asyncUseEffect();
  }, [rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards, ldClient, releaseRedemptionEngineV2]);
  return Boolean(items.length) && /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__cart-line-group"
  }, /*#__PURE__*/React.createElement(OrderHeader, {
    title: "".concat(title, " ").concat(isCheckout ? "" : " Order")
  }), items.map(function (item, index) {
    var _product$ProductVaria, _product$ProductVaria2, _item$AddOnProductDet, _item$AddOnProductDet2;

    var product = item.Product;
    return /*#__PURE__*/React.createElement(CartItem, {
      product: product,
      title: product.DisplayName,
      modNames: handleModNames(item.LineOptions || [], "SelectedOptions", "OptionName"),
      variantOptions: Object.values((product === null || product === void 0 ? void 0 : (_product$ProductVaria = product.ProductVariantModel) === null || _product$ProductVaria === void 0 ? void 0 : _product$ProductVaria.VariantProperties) || {}).filter(Boolean).join(", "),
      cost: item.LineCost || item.Price.Subtotal,
      imgUrl: product.ImageFilePath,
      quantity: item.Quantity,
      options: item.LineOptions,
      cartId: item.Id,
      min: product.MinimumQuantity || 1,
      max: product.MaximumQuantity || (product === null || product === void 0 ? void 0 : (_product$ProductVaria2 = product.ProductVariantModel) === null || _product$ProductVaria2 === void 0 ? void 0 : _product$ProductVaria2.AvailableInventory) || product.AvailableInventory,
      detailLink: product.DetailLink,
      deleteItem: deleteItem,
      patchItem: patchItem,
      key: item.Id,
      showCost: true,
      isCheckout: isCheckout,
      StoreProductId: product.StoreProductId || product.ProductId,
      stashEdit: function stashEdit(link, hash) {
        return _stashEdit(item, link, hash);
      },
      offlineCart: offlineCart,
      addOn: {
        name: item === null || item === void 0 ? void 0 : (_item$AddOnProductDet = item.AddOnProductDetails) === null || _item$AddOnProductDet === void 0 ? void 0 : _item$AddOnProductDet.Name,
        cost: item === null || item === void 0 ? void 0 : (_item$AddOnProductDet2 = item.AddOnProductDetails) === null || _item$AddOnProductDet2 === void 0 ? void 0 : _item$AddOnProductDet2.LineCost
      },
      rewardsBadge: (badges === null || badges === void 0 ? void 0 : badges["".concat(item.Product.ProductChainId, "-").concat(index + 1)]) || null,
      rewardsState: rewardsState,
      authenticationState: authenticationState,
      removeItemRewardsConfirmationFields: removeItemRewardsConfirmationFields,
      itemKey: "".concat(item.Product.ProductChainId, "-").concat(index + 1)
    });
  }));
};
export var Section = function Section(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement(Container, {
    className: "cb-cart__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, children)));
};